// extracted by mini-css-extract-plugin
export default {"container":"fileTile_container__AWeA5","tile":"fileTile_tile__MTbwl","img":"fileTile_img__AnAOt","preview":"fileTile_preview__reuau","name":"fileTile_name__O9QDN"};